import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import {theme} from "./stylesheet";
import Constitution from "./pages/Constitution";
import MemberRegistration from "./pages/MemberRegistration";
import Team from "./pages/Team";
import Refund from "./pages/Refund";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Undercons from "./pages/undercons";

// @ts-ignore

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>

          <ThemeProvider theme={theme}>
              <Routes>
                  <Route path="/" element={<App />}/>
                  <Route path="/Constitution" element={<Constitution/>}/>
                  <Route path="/member-registration" element={<MemberRegistration/>}/>
                  <Route path="/Team" element={<Team/>}/>
                  <Route path="/Refund" element={<Refund/>}/>
                  <Route path="/Privacy" element={<Privacy/>}/>
                  <Route path="/Terms" element={<Terms/>}/>
                  <Route path="/undercons" element={<Undercons/>}/>
              </Routes>
          </ThemeProvider>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
